if (window.APP_CONFIG?.freshChatEnabled) {
  document.addEventListener('turbo:load', function () {
    function getMeta(name) {
      var metaTag = document.querySelector(`meta[name="${name}"]`);
      if (metaTag) {
        return metaTag.content;
      }
      return '';
    }

    if (window.fcWidget) {
      window.fcWidget.init({
        token: window.APP_CONFIG.freshChatToken,
        host: window.APP_CONFIG.freshChatHost,
        externalId: getMeta('howler:user.email'),
        firstName: getMeta('howler:user.firstName'),
        lastName: getMeta('howler:user.lastName'),
        email: getMeta('howler:user.email'),
        phone: getMeta('howler:user.phone'),
      });
    }
  });
}
